(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
(() => {
  const prepareSlider = root => {
    const slider = root.querySelector('css-slider');
    if (!slider || slider.dataset.luminoRelatedReady) return;
    slider.dataset.luminoRelatedReady = 'true';
    const sync = () => {
      slider.querySelectorAll('.css-slider-button').forEach(button => {
        const disabled = button.classList.contains('disabled') || button.style.display === 'none';
        button.setAttribute('aria-disabled', String(disabled));
        button.tabIndex = disabled ? -1 : 0;
      });
      const counter = slider.querySelector('.css-slider-index-navigation');
      if (counter) counter.hidden = Number(slider.querySelector('.css-slider-total')?.textContent) < 2;
    };
    ['ready', 'change', 'reset', 'navigation'].forEach(name => slider.addEventListener(name, sync));
    slider.addEventListener('keydown', event => {
      const button = event.target.closest('.css-slider-button');
      if (event.key === ' ' && button) {
        event.preventDefault();
        if (button.getAttribute('aria-disabled') !== 'true') button.click();
      }
    });
    sync();
  };
  const initialize = (scope = document) => {
    scope.querySelectorAll('.lumino-related-products').forEach(root => {
      if (root.dataset.luminoRelatedBound) return;
      root.dataset.luminoRelatedBound = 'true';
      root.addEventListener('product-recommendations-loaded', () => prepareSlider(root));
      prepareSlider(root);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
